<template>
    <div class="a-copy-right copy-right">
        <span class="copy-right__label">
            Powered by:
        </span>
        <img 
            src="../../../assets/images/mvg-logo.png" 
            :alt="`${$t('copy-right_logo')}`"
            class="copy-right__logo"
        >
    </div>
</template>

<script>
export default {
    name: 'ACopyRight'
    
}
</script>

<style lang="scss">
@import "a-copy-right";
</style>
